export default __webpack_public_path__ + "static/media/isabel.010e149e.jpg";